module.exports = __webpack_public_path__ + "img/report.20052806.svg";